/* eslint-disable */
import {
  Divider,
  createStyles,
  Theme,
  withStyles,
  AccordionActions,
} from "@material-ui/core";
import { Button as ButtonMat } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DropzoneArea } from "material-ui-dropzone";
import React, { Component } from "react";
import { connect } from "react-redux";
import { addTeamLogo } from "../../utils/store/actions/users.actions";
import { TFunction } from "i18next";


const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    dropzoneEmail: {},
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });

  interface LogoConfigurationProps {
    teamId: string;
    addTeamLogo(files: FormData, teamId: string): void;
    t: TFunction;
    classes: any;
  }
class LogoConfiguration extends Component<LogoConfigurationProps, any> {
  constructor(props: LogoConfigurationProps) {
    super(props);
    this.state = {};
  }

  // UPLOAD LOGO
  handleChangeLogo(files: any) {
    const file: any = new FormData();
    file.append("file", files[0]);
    this.setState({
      files: file,
    });
  }
  uploadLogo() {
    this.props.addTeamLogo(this.state.files, this.props.teamId);
  }

  render() {
    const { classes, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="logoContainer"
        >
          <Typography className={classes.heading}>{t("Logo")}</Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DropzoneArea
            dropzoneClass={classes.dropzone}
            showFileNames
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewGridProps={{
              container: { spacing: 1, direction: "column" },
            }}
            previewChipProps={{ classes: { root: classes.previewChip } }}
            previewText="File:"
            acceptedFiles={["image/png"]}
            dropzoneText={t("UPLOAD") + "(png)"}
            filesLimit={1}
            onChange={this.handleChangeLogo.bind(this)}
          />
        </AccordionDetails>
        <Divider />
        <AccordionActions>
          <ButtonMat
            size="small"
            style={{ color: "#ae0064" }}
            onClick={() => {
              this.uploadLogo();
            }}
          >
            {t("SAVE")}
          </ButtonMat>
        </AccordionActions>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  addTeamLogo,
};

export default connect<typeof mapStateToProps, typeof mapDispatchToProps>(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(LogoConfiguration)));
